import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MultipleSelect from './MultipleSelect';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import SnackMsgBox from './SnackMsgBox';
import utils, {mapUtils} from '../utils';
import CheckboxList from './CheckboxList';
import Alert from './Alert';

import './LayerSelector.css';

import FullScreenDialog from './FullScreenDialog';

const styles = theme => ({
  bar2Indeterminate: {
    animation: 'none'
  },
  bar1Indeterminate: {
    animation: 'none'
  },
  padding: {
    paddingBottom: theme.spacing(1)
  }
});

class LayerSelector extends React.Component {
  state = {
    loading: false,
    errorMsg: null,
    dialogOpen: false,
    selectedLayer: null,
    preselectedLayers: null,
    showAlert: false
  };

  layers=[];
  unfilteredLayersCache = [];
  filteredLayersCache = [];

  handleLayerAttributes = (layerId, filtered) => {
    if (!this.layers[layerId]) return;
    
    const selectedLayer = this.props.layersById[layerId];

    selectedLayer.filtered = filtered;

    this.setState({
      selectedLayer: selectedLayer,
      dialogOpen: true
    });
  }

  handleSave = (attributes) => {
    if (this.state.selectedLayer === null) return;
    const layer = this.layers[this.state.selectedLayer.layerId]
    if (!layer) return;

    const attributesObj = {};
    attributes.map(a => attributesObj[a.record_id] = true);

    var obj = layer.toGeoJSON();
    obj.features = obj.features.filter(f => attributesObj[f.properties.record_id]);
    var data = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(obj));

    const link = document.createElement('a');
    link.href = data;
    link.setAttribute('download', 'multimodalnost_podatki.geojson');
    
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  handleClose = () => {
    this.setState({ dialogOpen: false });
  };

  handleLayerFilterClick = (item, wasFiltered, isChecked) => {
    
    this.handleLayerSelectClick(item, true);

    const layerId = item.layerId;
    if (wasFiltered) {
      this.layers[layerId] = this.unfilteredLayersCache[layerId];
    }
    else {
      this.layers[layerId] = this.filteredLayersCache[layerId];
    }
    
    this.handleLayerSelectClick(item, !isChecked);

  }

  handleLayerSelectClick = (layer, remove) => {

    const layerId = layer.layerId;
    const iconImg = layer.additional.icon;

    let self = this;

    const toggleLayers = (layers, map, layer, remove) => {
      const toggleLayer = (layer, remove) => {
        if (layer.items && layer.items.length > 0) {
          toggleLayers(layers, map, layer, remove);
          return;
        }
        
        const mapLayer = layers[layer.layerId];

        if (!mapLayer) return;

        if (remove) {
          map.removeLayer(mapLayer);
          self.setState({selectedLayer: null});
        }
        else {
          map.addLayer(mapLayer);
          self.setState({selectedLayer: layer});
        }
      }
      
      if (layer.items) {
        layer.items.map( (item) => toggleLayer(item, remove));
      }
      else {
        toggleLayer(layer, remove);
      }
    }
    
    toggleLayers(this.layers, this.props.leafletMap, layer, remove);

    if (remove || this.layers[layerId] !== undefined) return;

    if (layer.items && layer.items.length > 0) return;

    this.setState({loading: true});
    axios.all([ axios.get( '/geom/' + layerId ), axios.get( '/attribute-values/' + layerId )])
    .then(axios.spread( (geomResponse, attributeResponse ) => {
      if (self.layers[layerId] === undefined) {
        self.unfilteredLayersCache[layerId] = self.layers[layerId] = mapUtils.add(this.props.leafletMap, geomResponse.data.data, attributeResponse.data.data, iconImg, self.props.codeList, layer.additional.lineColor, layer.codeListKey, layer.additional.lineWidth, layer.additional.dashArray, layer.additional.opacity)
      }
      self.setState({selectedLayer: layer});
    }))
    .catch(error => {
      console.log(error);
      this.setState({errorMsg: error.message})
    })
    .then(() => //always executed
      this.setState({loading: false})
    );
  };

  componentDidUpdate(prevProps, prevState) {
    
    if (prevProps.layerListItems.length===0) return;  // trigger only once
    const objectId = utils.getQueryParameter('id');
    if (!objectId) return;

    const self = this;

    if (this.state.preselectedLayers !== null) return;
  
    axios.get( '/dostopnost-sodisc?id=' + objectId ).then(res => {

      let selectedLayer = null;

      const preselectedLayers = {};

      const filteredLayersBounds = [];

      let imeObjekta = null;

      let idGlavnegaSloja = null;

      if (res.data.values[131] && res.data.values[131].length > 0) {
        idGlavnegaSloja = 131;
      }
      else if (res.data.values[216] && res.data.values[216].length > 0) {
        idGlavnegaSloja = 216;
      }

      if (idGlavnegaSloja) {

        imeObjekta = res.data.values[idGlavnegaSloja][0].naziv_objekta;

        Object.keys(res.data.attributes).map(layerId => {
          const attributes = res.data.attributes[layerId];
          const values = res.data.values[layerId];
          if (!values || values.length === 0) return;

          const geomResponse = {
            data: {
              data: {}
            }
          };

          const attributeResponse = {
            data: {
              data: {}
            }
          };

          values.map(row=> {
            geomResponse.data.data[row.record_id] = {
              record_id: row.record_id,
              value: {
                resource_id: row._row,
                value: row.geometry
              }
            };

            const attributeValues = attributeResponse.data.data[row.record_id] = {};
            Object.keys(attributes).map(key => {
              const props = attributes[key];
              attributeValues[key] = {
                field: props.field,
                type: props.type,
                multivalued: props.multivalued,
                value: row[key]
              };
            });
          });

          if (self.layers[layerId] === undefined) {
            const layer = selectedLayer = self.props.layersById[layerId];
            preselectedLayers[layerId] = {
              count: values.length
            };
            
            const mapLayer = self.filteredLayersCache[layerId] = self.layers[layerId] = mapUtils.add(this.props.leafletMap, geomResponse.data.data, attributeResponse.data.data, layer.additional.icon, self.props.codeList, layer.additional.lineColor, layer.codeListKey, layer.additional.lineWidth, layer.additional.dashArray, layer.additional.opacity)

            filteredLayersBounds.push(mapLayer.getBounds());

            mapLayer.filtered = true;
          }

        });
      }

      let minLat = 90;
      let minLng = 180;
      let maxLat = -90;
      let maxLng = -180;

      filteredLayersBounds.map(bounds => {
        const ne = bounds.getNorthEast();
        
        if (ne.lat > maxLat ) maxLat = ne.lat;
        if (ne.lng > maxLng) maxLng = ne.lng;

        const sw = bounds.getSouthWest();
        
        if (sw.lat < minLat ) minLat = sw.lat;
        if (sw.lng < minLng) minLng = sw.lng;

      });

      if (self.filteredLayersCache[idGlavnegaSloja]) {
        this.props.leafletMap.flyToBounds([[minLat, minLng], [maxLat, maxLng]]);  //fitBounds
        self.filteredLayersCache[idGlavnegaSloja].getLayers()[0].openPopup();
      }

      this.setState((state, props) => {
        if (state.preselectedLayers) return null;
        return {
          showAlert: true,
          imeObjekta: imeObjekta,
          idObjekta: objectId,
          preselectedLayers: preselectedLayers,
          selectedLayer: selectedLayer
        };
      });

    });
  }

  render() {
    const { classes } = this.props;
    return(
        <div>
            <LinearProgress 
              classes={
                this.state.loading || this.props.loading ? null : {
                  bar1Indeterminate: classes.bar1Indeterminate,
                  bar2Indeterminate: classes.bar2Indeterminate,
                }
              }
            />
            <div className={classes.padding} />
            <Alert imeObjekta = {this.state.imeObjekta} idObjekta={this.state.idObjekta} show = {this.state.showAlert}></Alert>
            <CheckboxList layersById = {this.props.layersById} preselectedLayers = {this.state.preselectedLayers} items={this.props.layerListItems} collapsables = {this.props.collapsables} handleLayerAttributes = {(layerId, filtered) => this.handleLayerAttributes(layerId, filtered)} handleLayerFilterClick = {(item, filtered, checked) => this.handleLayerFilterClick(item, filtered, checked)} handleLayerSelectClick={(layerId, remove, iconImg) => this.handleLayerSelectClick(layerId, remove, iconImg)}></CheckboxList>
            <SnackMsgBox msg={this.state.errorMsg}></SnackMsgBox>
            <FullScreenDialog selectedLayer={this.state.selectedLayer}
              imeObjekta = {this.state.imeObjekta} 
              handleSave = {this.handleSave}
              handleClose = {this.handleClose} 
              open = {this.state.dialogOpen} 
              attributes={this.state.selectedLayer && this.layers[this.state.selectedLayer.layerId] && this.layers[this.state.selectedLayer.layerId].attributes}
            ></FullScreenDialog>
        </div>
    )
  }

  }

export default withStyles(styles)(LayerSelector);